<vui-header [displaySearchBox]="true" [showClearButton]="true" (search)="onSearchQuery($event)"></vui-header>
<div class="main-content">
  <app-search-page></app-search-page>
  <app-scheme-page></app-scheme-page>
</div>
<router-outlet />
<vui-footer></vui-footer>
